<div class="blocco_torta" style="position: relative" #canvasContainer>
  <canvas
    #scratchCanvas
    id="scratchCanvas"
    style="position: absolute; top: 0; left: 0"
  ></canvas>
  <img id="imgEnd" [src]="imgEnd" />
</div>
